<template>
  <el-dialog
    width="1160px"
    class="dialogs"
    title="测评点详情"
    :visible.sync="visible"
    destroy-on-close
    append-to-body
    :before-close="cancel"
  >
    <div class="content" v-if="point">
      <div class="images">
        <div>
          <el-image
            style="width: 700px; height: 700px"
            fit="contain"
            :src="
              point.url ||
              'https://chingshen-public.oss-cn-hangzhou.aliyuncs.com/statics/yuetu/default_500-700.jpg'
            "
            :preview-src-list="[point.url]"
          >
          </el-image>
        </div>
      </div>
      <div class="info" style="height: 711px">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="操作测评点" name="actionList">
            <template>
              <div class="item">
                <div class="label">问题描述</div>
                <div class="value">
                  <i class="el-icon-aim" /> {{ point.evaluation_rule.name }}
                </div>
              </div>
              <div class="item">
                <div class="label">问题状态</div>
                <div class="value">
                  <i
                    class="el-icon-remove-outline"
                    v-if="point.status === 'created'"
                  ></i>
                  <i class="el-icon-circle-check" v-else></i>
                  {{ filterStatus(point.status).label }}
                </div>
              </div>
              <div class="item">
                <div class="label">发现地点</div>
                <div class="value">
                  <i class="el-icon-location-outline"></i>
                  {{ point.poi ? point.poi : "无" }}
                </div>
              </div>
              <div class="item">
                <div class="label">经纬度</div>
                <div class="value">
                  <i class="el-icon-place"></i>
                  {{ point.longitude }},{{ point.latitude }}
                </div>
              </div>
              <div class="item">
                <div class="label">发现时间</div>
                <div class="value">
                  <i class="el-icon-alarm-clock"></i>
                  {{ point.created_at }}
                </div>
              </div>
              <div class="item">
                <div class="label">操作记录</div>
                <div
                  class="value actions-content"
                  :class="{ 'contract-actions': isAfterAppeal && point.status == 'appealed'   }"
                  >
                  <div
                    class="value"
                    v-if="!point.actions || point.actions.length === 0"
                  >
                    <span>暂无记录</span>
                  </div>
                  <div class="actions">
                    <div
                      class="action"
                      v-for="(item, index) in point.actions"
                      :key="index"
                    >
                      <div class="labels">
                        <span>
                          <i class="icon el-icon-user-solid"></i>
                          {{ item.doer.name }}
                        </span>
                        <span class="created_at">
                          {{ item.created_at | dateTimeBeautify }}
                        </span>
                      </div>
                      <div class="action-content">
                        <div class="value">
                          {{ item.content }}
                        </div>
                        <div
                          class="imageList"
                          v-if="item.files && item.files.length"
                        >
                          <div v-for="(file, index) in item.files" :key="index">
                            <a target="_blank" :href="file.url">
                              <i
                                class="el-icon-picture-outline"
                                v-if="filterFiles(file.type)"
                              />
                              <i class="el-icon-document" v-else />

                              <span> {{ file.filename }}</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="send-message">
                <el-input
                  v-if="isAfterAppeal && point.status == 'appealed'"
                  v-model="message"
                  clearable
                  placeholder="请输入内容"
                ></el-input>
                <el-row
                  :gutter="20"
                  v-if="isAfterAppeal && point.status == 'appealed'"
                >
                  <el-col :span="12">
                    <div class="grid-content bg-purple">
                      <el-button
                        @click="submit('approve')"
                        type="primary"
                        size="medium"
                        class="buttons"
                        >同意申诉</el-button
                      >
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <el-button
                      type="danger"
                      @click="submit('reject')"
                      size="medium"
                      class="buttons"
                      >拒绝申诉</el-button
                    >
                  </el-col>
                </el-row>
                <el-button
                  v-if="isOwner"
                  @click="removePoints"
                  type="danger"
                  size="medium"
                  class="buttons"
                  >删除测评点</el-button
                >
              </div>
            </template>
          </el-tab-pane>
          <el-tab-pane label="移动照片" name="second" style="height: 656.3px">
            <el-form
              :model="form"
              ref="numberValidateForm"
              label-width="80px"
              class="demo-ruleForm"
              :rules="rule"
            >
              <el-form-item label="新的分数" prop="score">
                <el-input
                  type="number"
                  v-model="form.score"
                  size="mini"
                ></el-input>
              </el-form-item>
              <el-form-item label="放到" prop="evaluation_rule_id">
                <el-cascader
                  v-model="form.evaluation_rule_id"
                  :options="rules"
                  :props="defaultProps"
                  clearable
                ></el-cascader>
              </el-form-item>
            </el-form>
            <div class="send-message">
              <el-button
                v-if="isOwner"
                @click="editPoints"
                type="primary"
                size="medium"
                class="buttons"
                >确认</el-button
              >
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { getEvaluationRuleTree } from "@/api/evaluation-rule";
import {
  getSubjectPoints,
  upDataActions,
  removePointApi,
  editPoints,
} from "@/api/project";
export default {
  props: {
    statuses: {
      type: Array,
      default: () => [],
    },
  },
  inject: ["taskDetail"],
  data() {
    return {
      visible: false,
      point: null,
      message: "",
      isCurrentUser: false,
      activeName: "actionList",
      form: {
        evaluation_rule_id: [],
        score: "",
      },
      changeSwitch: false,
      rules: [],
      rule: {
        evaluation_rule_id: [
          { required: true, message: "请选择新的规则", trigger: "blur" },
        ],
        score: [{ required: true, message: "请填写分数", trigger: "blur" }],
      },
      defaultProps: {
        children: "children",
        label: "name",
        value: "id",
        checkStrictly: true,
        // multiple: true,
      },
    };
  },
  computed: {
    filterFiles() {
      return (type) => {
        const typeList = ["image/jpeg", "image/png"];
        return typeList.indexOf(type) !== -1;
      };
    },
    filterStatus() {
      return (type) => {
        return this.statuses.filter((item) => item.value == type)[0];
      };
    },

    // 是否已经过申述期
    // 过了申诉期 运营账号可以对已复核状态进一步审核
    // 条件一：需要已过申诉期
    // 条件二：任务状态为已复核 (切换状态可能略有延迟，因此加了条件 2)
    isAfterAppeal() {
      const appealEndAt = moment(this.taskDetail.taskInfo.appeal_end_at);
      if (!appealEndAt.isValid()) {
        return false;
      }

      const isAfterAppealEndAt = moment().isAfter(appealEndAt);
      return (
        this.taskDetail.taskInfo.status == "reviewed" && isAfterAppealEndAt
      );
    },

    ...mapGetters([
      "isOwner", // 是否是该公司账号的创建人、所有人
    ]),
  },
  mounted() {},
  methods: {
    editPoints() {
      this.$refs["numberValidateForm"].validate((valid) => {
        if (valid) {
          let evaluation_rule_id =
            this.form.evaluation_rule_id[
              this.form.evaluation_rule_id.length - 1
            ];
          editPoints(this.point.id, {
            evaluation_rule_id,
            score: this.form.score,
          }).then((res) => {
            this.$message({ type: "success", message: "修改成功" });
            this.cencal();
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getTrees() {
      console.log(this.taskDetail.taskInfo);
      let evaluation_form_id = this.taskDetail.taskInfo.evaluation_form_id;
      getEvaluationRuleTree({ evaluation_form_id }).then((res) => {
        this.rules = res.data;
      });
    },
    handleClick(actionName) {
      console.log(actionName);
    },
    async removePoints() {
      this.$confirm("请谨慎删除，删除后无法恢复!", "是否确认删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        removePointApi({ id: this.point.id }).then(() => {
          this.$emit("upDataActions");
          this.$message.success("删除成功");
          this.cancel();
        });
      });
    },

    submit(action) {
      if (action == "reject" && !this.message.length) {
        this.$message({ type: "error", message: "拒绝申诉必须填写拒绝原因" });
        return;
      }
      upDataActions({
        action,
        message: this.message,
        id: this.point.id,
      }).then(() => {
        this.$emit("upDataActions");
        this.$message({ type: "success", message: "提交成功" });
        this.show(this.point);
        this.message = "";
      });
    },

    // 显示该 Dialog
    show(point) {
      this.point = point;
      this.getTrees();
      getSubjectPoints(point.id).then((res) => {
        this.point = res.data;
        this.visible = true;
      });
    },

    // 关闭该 Dialog
    cancel() {
      this.visible = false;
      this.point = null;
    },
  },
};
</script>

<style scoped lang="less">
.infoTitle {
  font-size: 24px;
  font-weight: bold;
  color: #000;
}

.info {
  position: relative;
}

.item {
  font-size: 14px;
  padding: 5px;

  .label {
    color: #333;
    font-weight: bold;
    padding-left: 0;
  }

  .value {
    color: #3d3d3d;
  }
}

.dialogs {
  /deep/ .el-dialog {
    margin-top: 10vh !important;
  }
}

.content {
  display: flex;
}

.images {
  width: 700px;
  height: 700px;
  // background: #e8e8e8;
  border: 1px dashed #e8e8e8;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.info {
  flex: 1;
  padding-left: 40px;
}

.action {
  &:first-child {
    padding: 0;
  }

  padding: 10px 0;

  .labels {
    // font-weight: bold;
    display: flex;
    justify-content: space-between;

    .created_at {
      font-size: 12px;
      color: #999;
    }
  }

  .action-content {
    margin: 5px 0;
    background-color: #f9f9f9;
    padding: 5px 10px;
    border-radius: 5px;
  }
}

.send-message {
  width: 380px;
  position: absolute;
  bottom: 0%;
  left: 50%;
  transform: translateX(-50%);

  .buttons {
    width: 100%;
    margin-top: 20px;
  }
}

.actions-content {
  height: 280px;
  margin-top: 10px;
  overflow-y: auto;
}

.contract-actions {
  height: 175px;
}

.actions-item {
  &:first-child {
    padding: 0;
  }

  padding: 10px 0;
}

.action-content {
  margin-left: 18px;
}

.actions-images {
  width: auto;
  height: 100px;
}
/deep/.pane-second {
  height: 659px;
}
/deep/ .el-tabs__content {
  position: static;
}
</style>
